<script setup lang='ts'>
const props = withDefaults(defineProps<{
  modelValue?: string | number
  options?: {
    label: string
    value: string | number
  }[] | Readonly<{ label: string, value: string | number }[]>
}>(), {

})

const emits = defineEmits({
  'update:modelValue': (_value?: string | number) => true,
})
</script>

<template>
  <div class="flex items-center">
    <button
      v-for="v in props.options" :key="v.value"
      class="px-sm py-1 text-3.5 rounded-md border-1 border-slate-3 mr-2"
      :class="[v.value === props.modelValue ? 'bg-blue-5 text-white' : 'bg-white text-slate-6']"
      @click="emits('update:modelValue', v.value)"
    >
      {{ v.label }}
    </button>
  </div>
</template>

<style lang='scss' scoped>

</style>
